import { sva } from '@agapi/ui/panda/css';

export const childCollectionsStyles = sva({
  //TODO: Remove childCollectionButtonBlue when we have a more scalable solution
  slots: ['childCollections', 'childCollectionButton', 'childCollectionButtonBlue'],
  base: {
    childCollections: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '3',
      py: '3',
      overflowX: 'visible',
      md: {
        display: 'flex',
        flexWrap: 'wrap'
      }
    },
    childCollectionButton: {
      backgroundColor: 'surface.primary.tonal.background',
      color: 'surface.primary.tonal.foreground',
      _hover: {
        backgroundColor: 'primary.100',
        boxShadow: '1px 2px 8px -3px rgba(0, 0, 0, 0.18)'
      },
      _active: {
        backgroundColor: 'primary.300'
      }
    },
    childCollectionButtonBlue: {
      backgroundColor: 'surface.secondary.subdued.background',
      color: 'surface.secondary.tonal.foreground',
      _hover: {
        backgroundColor: 'secondary.50',
        boxShadow: '1px 2px 8px -3px rgba(0, 0, 0, 0.18)'
      },
    }
  }
});
